/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useHistory } from 'react-router-dom';
import { HiDownload } from 'react-icons/hi';
import { MdFilterList, MdSearch } from 'react-icons/md';
import * as Yup from 'yup';
import { useToast } from '../../hooks/toast';
import Input from '../../components/Input';
import Button from '../../components/Button';
import CardOrdersTable from './Components/CardOrdersTable';
import FiltersModal from './Components/FiltersModal';
import CreateCardOrderModal from './Components/CreateCardOrderModal';
import { TicketOrders, ArrayFilters } from '../../interfaces/ticket';
import TicketService from '../../services/ticket';
import DownLoadFile from '../../utils/DownLoadFile';
import LoaderModal from '../../components/LoaderModal';
import PlusCreditOrange from '../../assets/PlusCreditOrange.svg';
import { Row, Column, IconContainer } from '../../styles/components';
import Modal from '../../components/Modal';
import AuthService from '../../services/auth';
import getValidationErrors from '../../utils/getValidationErrors';

import {
  Container,
  Title,
  StatusRow,
  FiltersContainer,
  DetailLink,
  ButtonsContainer,
  FormWrapper,
  ModalContent,
  LinkModal,
} from './styles';

const CardsOrder: React.FC = () => {
  const { addToast } = useToast();
  const services = { TicketService: new TicketService() };
  const formRef = useRef<FormHandles>(null);
  const formRefRelatorio = useRef<FormHandles>(null);
  const { push } = useHistory();
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [page, setpage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(30);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [orders, setOrders] = useState<TicketOrders>({} as TicketOrders);
  const [modalRelatorio, setModalRelatorio] = useState<boolean>(false);
  const [titular, setTitular] = useState<any>();
  const [tipoRelatorio, setTipoRelatorio] = useState<string>('');
  const authService = { AuthService: new AuthService() };

  const [filters, setFilters] = useState<ArrayFilters>({
    filters: [{ page }, { quantity: perPage }],
  });

  const schemaRelatorio = Yup.object().shape({
    email: Yup.string().required('É necessário informar o email'),
  });

  const getTitular = useCallback(async () => {
    try {
      setLoading(true);
      const response = await authService.AuthService.getTitular();
      await setTitular(response.data.DadosDoTitular);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  }, []);

  const getTicketOrders = useCallback(async () => {
    try {
      setLoading(true);
      const response = await services.TicketService.getOrders(filters);
      response.data.ListaPedidoDeCartao.reverse();
      setOrders(response.data);
      setTotalRows(response.data.ListaPedidoDeCartaoTotal);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    getTicketOrders();
    getTitular();
  }, [page, perPage, filters]);

  const handleChangePerPage = useCallback(
    async (newPage: number) => {
      setpage(newPage);
      setFilters({ filters: [...filters.filters, { page: newPage }] });
    },
    [filters],
  );

  const handleChangeRowsPerPage = useCallback(
    async (newPerPage: number, OldPerPage: number) => {
      setPerPage(newPerPage);
      setpage(OldPerPage);
      setFilters({
        filters: [
          ...filters.filters,
          { page: OldPerPage },
          { quantity: newPerPage },
        ],
      });
    },
    [filters],
  );

  const handleApplyFilter = useCallback((filtersOptions: any) => {
    setFilters({
      filters: [
        ...filters.filters,
        filtersOptions.start_date && {
          'start-date': filtersOptions.start_date,
        },
        filtersOptions.end_date && { 'end-date': filtersOptions.end_date },
        filtersOptions.status !== '' && { status: filtersOptions.status },
      ],
    });
    setShowModal(false);
  }, []);

  const handleClearFilters = useCallback(() => {
    localStorage.removeItem('@TransfacilPJ:cardOrderStartDate');
    localStorage.removeItem('@TransfacilPJ:cardOrderEndDate');
    setFilters({
      filters: [{ page }, { quantity: perPage }],
    });
  }, []);

  const handleNumberOrderFilter = useCallback(
    (data: any) => {
      setFilters({
        filters: [...filters.filters, { 'code-order': data.search }],
      });
    },
    [filters],
  );

  const handleAdd = useCallback(async (quantity: string) => {
    try {
      setLoading(true);
      const response = await services.TicketService.createOrder({ quantity });

      addToast({
        type: 'success',
        title: 'Sucesso',
        description: 'Pedido de cartão feito com sucesso!!',
      });

      push(
        `/pedidos-de-cartao/${response.data.DadosDePedidoDeCartao.CodigoPedido}`,
      );

      setLoading(false);
      setShowAddModal(false);
    } catch (err: any) {
      const { ...error } = err;
      setLoading(false);

      if (error.response.data.Summary) {
        addToast({
          type: 'error',
          title: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].ErrorMessage}`,
          description: `${error.response.data.Summary.ErrorCollection.DataValidationErros[0].InternalErrorMessage}`,
        });
      }
    }
  }, []);

  function relatorio() {
    push('/agendado');
  }

  const handleReport = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [{ 'file-type': type === 'csv' ? 'C' : 'P' }],
    };
    try {
      setLoadingModal(true);
      const response = await services.TicketService.getTicketOrderReport(
        reportFilters,
        type,
      );
      DownLoadFile(response.data, `relatório.${type}`);
      setLoadingModal(false);
    } catch (err: any) {
      setLoadingModal(false);
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const RelatorioAgendados = useCallback(async (type: string) => {
    const reportFilters = {
      filters: [{ 'file-type': type === 'csv' ? 'C' : 'P' }],
    };
    try {
      const response = await services.TicketService.getTicketOrderReport(
        reportFilters,
        type,
      );
    } catch (err: any) {
      const { ...error } = err;
      console.error(error);
    }
  }, []);

  const openModalCSV = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('csv');
    RelatorioAgendados('csv');
  }, []);

  const openModalPDF = useCallback(() => {
    setModalRelatorio(true);
    setTipoRelatorio('pdf');
    RelatorioAgendados('pdf');
  }, []);

  const handleReportAsync = useCallback(
    async (type: string, Email: string) => {
      try {
        setLoadingModal(true);
        const reportFilters = {
          filters: [
            {
              'file-type': type === 'csv' ? 'C' : 'P',
              email: Email,
              user: titular.IdentificadorTitular,
              async: true,
            },
          ],
        };

        await services.TicketService.getTicketOrderReport(reportFilters, type);

        addToast({
          type: 'success',
          title: 'Relatório exportado com sucesso, por favor, aguarde.',
        });

        setLoadingModal(false);
      } catch (err: any) {
        setLoadingModal(false);

        addToast({
          type: 'error',
          title: `${err.response.data.message} ${err.response.data.sub_message}`,
        });
        const { ...error } = err;
        console.error(error);
      }
    },
    [titular],
  );

  const handleSubmitRelatorio = useCallback(
    async (data: any) => {
      try {
        formRefRelatorio.current?.setErrors({});
        await schemaRelatorio.validate(data, {
          abortEarly: false,
        });
        setLoading(true);
        await handleReportAsync(tipoRelatorio, data.email);
        setLoading(false);
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);
          formRefRelatorio.current?.setErrors(errors);
        }
      }
    },
    [tipoRelatorio, titular],
  );

  const getStatusText = useCallback((status: any) => {
    const statusOptions: any = {
      C: 'Pronto para retirada na Central',
      F: 'Finalizado',
      E: 'Em Andamento',
    };
    return statusOptions[status];
  }, []);

  useEffect(() => {
    localStorage.removeItem('@TransfacilPJ:cardOrderStartDate');
    localStorage.removeItem('@TransfacilPJ:cardOrderEndDate');
  }, []);

  return (
    <Container>
      <Row className="titleWrapper">
        <Column small="1" medium="1" large="1">
          <IconContainer align="center">
            <img src={PlusCreditOrange} alt="Pedido de cartão" />
          </IconContainer>
        </Column>
        <Column small="10" medium="10" large="10" className="TitleContainer">
          <div>
            <Title>Pedidos de Cartão</Title>
            {/* <ButtonsContainer>
              <div className="buttonsInitial">
                <Button
                  color="orange"
                  padding="1"
                  type="button"
                  className="pedido"
                  onClick={() => setShowAddModal(true)}
                >
                  SOLICITAR CARTÕES
                </Button>
              </div>
            </ButtonsContainer> */}
            <div
              style={{
                color: 'red',
                border: '2px solid var(--orange)',
                borderRadius: '10px',
                width: 'auto',
                maxWidth: '850px',
                padding: '5px',
                marginTop: '10px',
                fontSize: '13px',
              }}
            >
              <p style={{ fontWeight: 'bold' }}>
                *Solicitação de cartão indisponível no momento.
              </p>
              <p>
                <br />
                Temporariamente solicitações de cartões adicionais serão
                realizadas presencialmente no posto Floresta, mediante
                apresentação do código de titular da empresa, documento que
                comprove a quantidade total de funcionários da empresa nos
                últimos 30 dias (cópia do CAGED ou cópia Carteira de
                Trabalho/Contrato de Estágio ou Evento 2200 todos no e-social),
                bem como autorização de retirada.
              </p>
              <p style={{ fontWeight: 'bold' }}>
                Para mais informações entre em contato com nosso SAC.
              </p>
              <p>
                <br />
                Obs.:Não serão cedidos novos cartões BHBUS, caso sua empresa
                possua cartões sem pedido de carga por mais de 90 dias e/ou
                bloqueados sem emissão de segunda via.
              </p>
            </div>
          </div>
        </Column>
      </Row>
      <Row>
        <Column small="12" medium="12" large="12">
          <FiltersContainer>
            <div className="filter">
              <Button
                color="aside-background"
                padding="1"
                textBlack
                type="button"
                className="pdf"
                onClick={() => setShowModal(true)}
              >
                <MdFilterList />
                FILTROS
              </Button>
            </div>
            <div className="search">
              <Form ref={formRef} onSubmit={handleNumberOrderFilter}>
                <Input
                  id="search"
                  name="search"
                  type="number"
                  placeholder="Busca por código do pedido"
                />
                <Button
                  color="orange"
                  padding="1"
                  type="submit"
                  className="searchButton"
                >
                  <MdSearch size={20} />
                </Button>
              </Form>
            </div>
            <div className="buttonsContainer">
              <Button
                color="aside-background"
                padding="1"
                type="button"
                className="clearFilters"
                onClick={handleClearFilters}
              >
                <MdFilterList />
                LIMPAR FILTROS
              </Button>
              <Button
                color="purple"
                padding="1"
                type="button"
                className="csv"
                onClick={() => {
                  return titular.AsyncReport === true
                    ? openModalCSV()
                    : handleReport('csv');
                }}
              >
                <HiDownload />
                GERAR CSV
              </Button>
              <Button
                color="purple"
                padding="1"
                type="button"
                className="pdf"
                onClick={() => {
                  return titular.AsyncReport === true
                    ? openModalPDF()
                    : handleReport('pdf');
                }}
              >
                <HiDownload />
                GERAR PDF
              </Button>
            </div>
          </FiltersContainer>
        </Column>
      </Row>

      <Row>
        <Column small="12" medium="12" large="12">
          <CardOrdersTable
            data={orders.ListaPedidoDeCartao}
            columns={[
              {
                name: 'Código do pedido',
                selector: 'CodigoPedido',
                maxWidth: '20%',
                cell: ({ CodigoPedido }: any) => (
                  <DetailLink
                    onClick={() => push(`/pedidos-de-cartao/${CodigoPedido}`)}
                  >
                    {CodigoPedido}
                  </DetailLink>
                ),
              },
              {
                name: 'Data do pedido',
                selector: 'DataPedido',
                maxWidth: '20%',
              },
              {
                name: 'Status',
                center: true,
                maxWidth: '90%',
                selector: 'StatusPedido',
                cell: ({ StatusPedido }: any) => (
                  <StatusRow status={StatusPedido}>
                    {getStatusText(StatusPedido)}
                  </StatusRow>
                ),
              },
              {
                name: 'Via',
                selector: 'IndSegundaVia',
                maxWidth: '10%',
                cell: ({ IndSegundaVia }: any) => (
                  <div>{IndSegundaVia === 'N' ? '1ª via' : '2ª via'}</div>
                ),
              },
            ]}
            loading={loading}
            perPage={perPage}
            totalRows={totalRows}
            onChangePage={handleChangePerPage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            emptyText="Nenhum Pedido de Cartão"
          />
        </Column>
      </Row>

      {showModal && (
        <FiltersModal
          handleClose={() => setShowModal(false)}
          filters={filters}
          handleApplyFilter={handleApplyFilter}
          show={showModal}
          title="Filtros"
        />
      )}
      {showAddModal && (
        <CreateCardOrderModal
          handleClose={() => setShowAddModal(false)}
          handleAdd={handleAdd}
          show={showAddModal}
          title="Solicitar Cartões"
        />
      )}
      {modalRelatorio && (
        <Modal
          handleClose={() => setModalRelatorio(false)}
          show={modalRelatorio}
          title="Agendamento de Relatório"
        >
          <ModalContent>
            <Form ref={formRefRelatorio} onSubmit={handleSubmitRelatorio}>
              <FormWrapper>
                <p>Estamos processando os dados do pedido do Relatório.</p>
                <p>
                  <LinkModal onClick={relatorio}>Clique Aqui!</LinkModal>
                  Para abrir o menu Relatórios Agendados e acompanhar o Pedido
                  solicitado. Quando este processo for finalizado basta fazer o
                  download do arquivo.
                </p>
              </FormWrapper>
            </Form>
          </ModalContent>
        </Modal>
      )}
      {loadingModal && (
        <LoaderModal
          title="Carregando"
          show={loadingModal}
          handleClose={() => setLoadingModal(false)}
        />
      )}
    </Container>
  );
};

export default CardsOrder;
